module.exports = __webpack_public_path__ + "img/ic_20_report_progress.16906796.svg";